/**
 * @generated SignedSource<<c821c6fe8f7cc0946a93449d83b26ed5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ConvoAiSkillSource = "ANTHROPIC" | "STRATUS" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef$data = {
  readonly convoai_availableSkills: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "ConvoAiSkill";
        readonly category: string | null;
        readonly color: string | null;
        readonly description: string | null;
        readonly displayName: string | null;
        readonly helpText: string | null;
        readonly iconKey: string | null;
        readonly iconUrl: string | null;
        readonly id: string;
        readonly integrationKeys: ReadonlyArray<string>;
        readonly integrations: ReadonlyArray<{
          readonly displayName: string | null;
          readonly iconUrl: string | null;
          readonly id: string | null;
          readonly key: string;
        }>;
        readonly name: string;
        readonly slashCommand: string | null;
        readonly source: ConvoAiSkillSource;
        readonly tags: ReadonlyArray<string>;
        readonly version: string | null;
      } | null;
    }> | null;
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    }> | null;
    readonly metadata: {
      readonly anthropicCount: number;
      readonly isDegraded: boolean;
      readonly stratusCount: number;
    };
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null;
    };
    readonly totalCount: number;
  } | null;
  readonly " $fragmentType": "browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef";
};
export type browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef$key = {
  readonly " $data"?: browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef">;
};

import browseSkillsUnifiedPaginationQuery_graphql from './browseSkillsUnifiedPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "convoai_availableSkills"
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v3 = {
  "kind": "ScalarField",
  "name": "iconUrl"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchKeyword"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": browseSkillsUnifiedPaginationQuery_graphql
    }
  },
  "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef",
  "selections": [
    {
      "alias": "convoai_availableSkills",
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        },
        {
          "kind": "Variable",
          "name": "searchKeyword",
          "variableName": "searchKeyword"
        }
      ],
      "concreteType": "ConvoAiAvailableSkillsResult",
      "kind": "LinkedField",
      "name": "__browseSkills__convoai_availableSkills_connection",
      "plural": false,
      "selections": [
        {
          "concreteType": "ConvoAiSkillEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "ConvoAiSkill",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "__typename"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "name"
                },
                {
                  "kind": "ScalarField",
                  "name": "description"
                },
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "slashCommand"
                },
                (v3/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "iconKey"
                },
                {
                  "kind": "ScalarField",
                  "name": "color"
                },
                {
                  "kind": "ScalarField",
                  "name": "helpText"
                },
                {
                  "kind": "ScalarField",
                  "name": "source"
                },
                {
                  "kind": "ScalarField",
                  "name": "tags"
                },
                {
                  "kind": "ScalarField",
                  "name": "category"
                },
                {
                  "kind": "ScalarField",
                  "name": "integrationKeys"
                },
                {
                  "concreteType": "ConvoAiSkillIntegration",
                  "kind": "LinkedField",
                  "name": "integrations",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "key"
                    },
                    (v1/*: any*/),
                    (v2/*: any*/),
                    (v3/*: any*/)
                  ]
                },
                {
                  "kind": "ScalarField",
                  "name": "version"
                }
              ]
            },
            {
              "kind": "ScalarField",
              "name": "cursor"
            }
          ]
        },
        {
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            },
            {
              "kind": "ScalarField",
              "name": "hasPreviousPage"
            },
            {
              "kind": "ScalarField",
              "name": "startCursor"
            },
            {
              "kind": "ScalarField",
              "name": "endCursor"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "totalCount"
        },
        {
          "concreteType": "ConvoAiSkillListMetadata",
          "kind": "LinkedField",
          "name": "metadata",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "anthropicCount"
            },
            {
              "kind": "ScalarField",
              "name": "stratusCount"
            },
            {
              "kind": "ScalarField",
              "name": "isDegraded"
            }
          ]
        },
        {
          "concreteType": "QueryError",
          "kind": "LinkedField",
          "name": "errors",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "message"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "6c35cc4125ef7d7282e5c0de48a97f2e";

export default node;
